export const color = "#11bba6"
